import React from "react";
import { connect } from "react-redux";
import { Layout, Row, Col } from "antd";
import HeaderNavigationContainer from "../../components/HeaderNavigation/container";
import Block from "../../components/Block";
import LogoCarousel from "../../components/LogoCarousel";
import BackgroundBlock from "../../components/BackgroundBlock";
import FooterContainer from "../../components/Footer/container";
import ProfilesList from "./ProfilesList";
import {getBackgroundImage} from "../../infrastructure/helpers/getBackgroundImage"
import intl from "./intl";

const { Header, Content } = Layout;
function About(props) {
  return (
    <Layout
      className="layout homebg"
      style={{
        background: `url(${getBackgroundImage('about')}) no-repeat bottom center fixed`,
        backgroundSize: "cover"
      }}
    >
      <HeaderNavigationContainer />
      <Header className="">
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "10%"
          }}
        >
          <h1 className="header_headline" style={{ color: "#1abc9c" }}>
            {intl.headline[props.language]}
          </h1>
          <div
            style={{
              position: "absolute",
              zIndex: 1,
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <button
              onClick={() => window.scrollBy(0, 700)}
              className="arrow_button"
            >
              <i className="arrow arrow_down" />
            </button>
          </div>
        </div>
      </Header>
      <Content>
        <Block
          invertColors
          headline={intl.block1.headline[props.language]}
          headlineBody={intl.block1.subheadline[props.language]}
          body={intl.block1.body[props.language]}
          buttonTxt={intl.block1.button[props.language]}
          displaySignature
        />

        <Row style={{ backgroundColor: "#fff", padding: "50px 0 50px" }}>
          <div style={{ padding: "20px 300px 20px" }}>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid #1ABC9C"
              }}
            />
            <div
              style={{
                color: "#1ABC9C",
                backgroundColor: "#fff",
                display: "inline-block",
                /* position: absolute, */
                padding: "0 20px",
                top: "-30px",
                position: "relative",
                fontSize: "20px"
              }}
            >
              {props.language === "en" ? "Our consultants" : "Vores konsulenter"}
            </div>
          </div>

          <Col sm={24} md={{ span: 16, offset: 4 }}>
            <ProfilesList language={props.language} />
          </Col>
        </Row>
        <LogoCarousel />
        <BackgroundBlock
          subHeadline={intl.block5.subheadline[props.language]}
          headline={intl.block5.headline[props.language]}
        />
      </Content>
      <FooterContainer />
    </Layout>
  );
}

function mapStateToProps(state) {
  return {
    language: state.preference.language
  };
}

export default connect(mapStateToProps)(About);



// WEBPACK FOOTER //
// ./src/pages/About/index.js